import {
  type Category,
  type Product,
  type ProductResponse,
  type QueryParam,
} from '@/types'
import { api } from '@/utils'
import { convertQueryParam } from '@/utils/next-util'
import { isEmpty } from 'lodash'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { useMutation } from 'react-query'

export const useGetProductsByCategory = () => {
  const { query } = useRouter()
  const [products, setProducts] = useState<Product[]>([])
  const [, setCurrentPage] = useState(1)
  const [categoryActive, setCategoryActive] = useState<Category | undefined>()

  const transformData = (data: ProductResponse) => {
    const products = data.data.map((item: Product) => {
      return item
    })
    return products
  }

  const { mutate: getProducts } = useMutation(
    'products',
    async (values: {
      currentPage?: number
      categoryDefault?: string
      limit?: number
      sortBy?: string
      featured?: boolean
      sortType?: string
      catDisplay?: boolean
      search?: string | undefined | string[]
    }) => {
      let url = `api/products`
      const queryParams = {
        ...query,
        ...(values.search ? { fullTextSearch: values.search } : {}),
        ...(values.sortType ? { sortType: values.sortType } : {}),
        ...(values.sortBy ? { sortBy: values.sortBy } : {}),
        ...(values.catDisplay ? { catDisplay: values.catDisplay } : {}),
        ...(values.featured ? { featured: values.featured } : {}),
        ...(values.categoryDefault
          ? { catId: values.categoryDefault || '' }
          : {}),
        limit: values.limit || 20,
        page: values.currentPage ? String(values.currentPage) : '1',
      }
      if (!isEmpty(queryParams) && queryParams) {
        const param = convertQueryParam(queryParams as QueryParam)
        url = `api/products?${param}`
      }
      return api(url, {
        method: 'GET',
        baseURL: process.env.NEXT_PUBLIC_CATALOG_API_URL,
      })
    }
  )
  return {
    getProducts,
    categoryActive,
    setCategoryActive,
    setCurrentPage,
    products,
    setProducts,
    transformData,
  }
}
